import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import CTASection from "../components/sections/CTASection";
import { SITE_URL } from "../config/site";

export default function Corrections() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "Corrections Policy",
    "url": `${SITE_URL}/corrections`,
    "publisher": { "@type": "Organization", "name": "Indiana Accident Aid", "url": SITE_URL },
  };
  return (
    <>
      <SEO
        title="Corrections Policy | Indiana Accident Aid"
        description="How to report an error in an Indiana Accident Aid article and how we review and correct our content."
        schema={schema}
        canonical={`${SITE_URL}/corrections`}
      />
      <section className="pt-12 md:pt-20 pb-8 px-6 bg-bone" data-testid="corrections-policy">
        <div className="max-w-3xl mx-auto">
          <div className="overline mb-3">Accuracy Matters</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5">Corrections Policy</h1>
          <p className="text-lg md:text-xl text-charcoal-soft leading-relaxed">
            We work hard to keep our Indiana guides accurate and current. If something looks wrong,
            we want to know — and we will fix it.
          </p>
        </div>
      </section>
      <section className="px-6 pb-16">
        <div className="max-w-3xl mx-auto space-y-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-display font-bold text-forest mb-3">How to report an error</h2>
            <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">
              Use our <Link to="/contact" className="text-forest underline hover:text-terracotta">contact form</Link> and
              tell us the article title or link and what appears to be incorrect. Specific details
              (a statute number, a date, or a quoted sentence) help us review quickly.
            </p>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-display font-bold text-forest mb-3">How we handle corrections</h2>
            <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">
              Our editorial team reviews every report against primary sources such as the official
              Indiana Code and government agencies. If a factual error is confirmed, we correct the
              article and update its modified date. Minor typo fixes are made without a formal note;
              substantive factual corrections are made promptly and transparently.
            </p>
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-display font-bold text-forest mb-3">Our standard</h2>
            <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">
              Indiana Accident Aid follows an evidence-first policy: we would rather remove or
              de-specify an unverifiable claim than leave a figure we cannot support. Read more in our{" "}
              <Link to="/editorial-policy" className="text-forest underline hover:text-terracotta">Editorial Policy</Link>.
            </p>
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
